"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.syphilisScreeningMessages = exports.SyphilisScreening = void 0;
const schema_1 = require("../../../../schema");
var SyphilisScreening;
(function (SyphilisScreening) {
    SyphilisScreening["POSITIVE"] = "POSITIVE";
    SyphilisScreening["NEGATIVE"] = "NEGATIVE";
    SyphilisScreening["IN_PROGRESS"] = "IN_PROGRESS";
})(SyphilisScreening || (exports.SyphilisScreening = SyphilisScreening = {}));
exports.syphilisScreeningMessages = {
    [SyphilisScreening.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.treponemaPallidum.syphilisScreening.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [SyphilisScreening.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.treponemaPallidum.syphilisScreening.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [SyphilisScreening.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.treponemaPallidum.syphilisScreening.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
const syphilisScreening = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(SyphilisScreening.POSITIVE),
    schema_1.Schema.singleChoiceItem(SyphilisScreening.NEGATIVE),
    schema_1.Schema.singleChoiceItem(SyphilisScreening.IN_PROGRESS)
]).interpretation({
    vocab: "ltx",
    code: "treponema_pallidum_org_screening_procedure"
});
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ syphilisScreening })
    .tag({ vocab: "snomed", code: "72904005" })
    .tag({ vocab: "snomed", code: "20135006" });
